import React, { useState, useEffect, useRef } from 'react';
import { Typography, Stack, Link, ToggleButton, ToggleButtonGroup, Select, MenuItem, TextField, Button, Box, Pagination, IconButton, FormHelperText } from "@mui/material";
import AWS from 'aws-sdk';
import { useQuery, useMutation, gql } from "@apollo/client";
import parser from 'html-react-parser';
import moment from 'moment';
import Taglistabb from '../components/Taglistabb';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import CardContent from '@mui/material/CardContent';
import Getuserinfo from "../components/Getuserinfo";
import GetImage from "../components/GetImage";
import GetSignedFileUrl from "../components/GetSignedFileUrl";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { NavLink } from "react-router-dom";
import sortArray from 'sort-array';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import OpenInBrowserIcon from '@mui/icons-material/OpenInBrowser';
import QuickreplyIcon from '@mui/icons-material/Quickreply';
import LinkIcon from '@mui/icons-material/Link';
import ShareIcon from '@mui/icons-material/Share';
import { yellow, red, green, blue } from '@mui/material/colors';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Tooltip from '@mui/material/Tooltip';

import "../components/formatlinks.css";

const blogquery = gql`
  query blogs($accessgroups: [String]) {
    getpostscats(accessgroups: $accessgroups, posttype: ["resource"]) {
     id
     title
     posttext
     author
     authoremail
     otherauthors
     postimage {
      filename
      fileext
      fileuuid
      filedate
      filelink
     }
     file {
      filename
      fileext
      fileuuid
      filedate
      filelink
     }
     resourcelink {
      resourcelinkname
      resourcelinkurl
     }
     tags
     posttype
     blog
     accessgroups
     response {
      responderemail
      responsetext
      responsedate
     }
     position
     createdAt
     archive
    } 
  }
`;

const blogqueryrefresh = gql`
  query blogs {
    getpostscats(accessgroups: ["staff","leadership"], posttype: ["resource"]) {
     id
     title
     posttext
     author
     authoremail
     otherauthors
     postimage {
      filename
      fileext
      fileuuid
      filedate
      filelink
     }
     file {
      filename
      fileext
      fileuuid
      filedate
      filelink
     }
     resourcelink {
      resourcelinkname
      resourcelinkurl
     }
     tags
     posttype
     blog
     accessgroups
     response {
      responderemail
      responsetext
      responsedate
     }
     position
     createdAt
     archive
    } 
  }
`;


const deletequery = gql`
  mutation removepost($id: ID) {
    deletepost (id: $id)
  }
`;

const archivequery = gql`
  mutation editpostarchive($id: ID, $archive: String) {
    updatepostarchive(id: $id, archive: $archive) {
      id
      archive
    }
  }`
;

const blognamesquery = gql`
  query blog {
    getblogs {
      id
      idnumber
      blogtitle
      blogdescription
    }
  }
`;


function Getresources() {
  let userinfo = useSelector((state) => state.userinfo);
  const user = userinfo.user;
  const accessgroups = userinfo.accessgroups;
  console.log("accessgroups=", accessgroups);
  const { data, loading, error, refetch } = useQuery(blogquery, { variables: { accessgroups },});
  const [ removepost, { data2, loading2, error2 } ] = useMutation(deletequery, { refetchQueries: [{ query: blogqueryrefresh }],});
  const [ editpostarchive, { data3, loading3, error3 } ] = useMutation(archivequery, { refetchQueries: [{ query: blogqueryrefresh }],});
  const blognamesq = useQuery(blognamesquery);
  const [ rows, setRows ] = useState(null);
  const [ rowsall, setRowsAll ] = useState([]);
  const [ numrows, setNumRows ] = useState(0);
  const [ dataloaded, setDataLoaded ] = useState(false);
  const [ gotolink, setGoToLink] = useState("/getresources");
  const [ seltags, setSelTags ] = useState([]);
  const [ authoremails, setAuthorEmails ] = useState([]);
  const [ authornames, setAuthorNames ] = useState([]);
  const [ selectedauthor, setSelectedAuthor ] = useState("");
  const [ clearthetags, setClearTheTags ] = useState(false);
  const [ tagstoset, setTagsToSet ] = useState([]);
  const [ tagstatus, setTagStatus ] = useState("tagsnotset");
  const [ selectedname, setSelectedName ] = useState("All Authors");
  const [ ranchecksession, setRanCheckSession ] = useState(false);
  const [ pageSize, setPageSize ] = useState(9);
  const [ pagination, setPagination ] = useState({ count: 0, page: 1, from: 0, to: pageSize });
  const [ paginationlabel, setPaginationLabel ] = useState("");
  const [ page, setPage ] = useState(1);
  const [ sortby, setSortBy ] = useState("createdAt");
  const [ raninit, setRanInit ] = useState(false);
  const [ ranfind, setRanFind ] = useState(false);
  const [ blognames, setBlognames ] = useState([]);
  const [ showblognames, setShowblognames] = useState(false);
  const [ blogsel, setBlogsel] = useState("All Blogs");
  const [ showit, setShowIt ] = useState([]);
  const [ searchtext, setSearchText ] = useState("");
  const [ runsearchtext, setRunSearchText] = useState(false);
  const [ linktocopy, setLinktocopy] = useState("Karen");
  const textAreaRef = useRef(null);

  //let userinfo = useSelector((state) => state.userinfo.user);

  //const user = JSON.parse(localStorage.getItem("user"));
  //if (userinfo.length===0) {
    //userinfo = Object.assign({}, user);
  //}
  //console.log("userinfo=", userinfo);

  const navigate = useNavigate();

  //console.log("seltags=", seltags);
  //console.log("userinfo=", userinfo);

  /**************************** main filters  ****************************/

  // this retrieves the blogs according to seltags or selectedname values
  // if seltags has a value filter by the tags selected
  // if no tags filter by selected name
  const findblogs = () => {
    console.log("Karen-dataloaded=",dataloaded,rowsall)
    if (dataloaded && rowsall.length>0) {
      let rowstemp = rowsall;
      console.log("rowsall=", rowsall);
      //console.log("seltags=", seltags);
      if (searchtext.length>0) {
        rowstemp = rowstemp.filter((rowf) => (rowf.title+rowf.posttext).toLowerCase().indexOf(searchtext)>-1);
      }

      if (seltags.length>0) {
        rowstemp = rowstemp.filter((rowf) => rowf.tags.some(item => seltags.includes(item)));
      } 

      if (selectedname!=="All Authors") {
        let selectedemail = getemail();
        rowstemp = rowstemp.filter((rowf) => rowf.authoremail===selectedemail);
      }

      setRows(rowstemp);
      setRanFind(true);
    }
  }

  // this retrieves the blogs according to seltags or selectedname values
  // if seltags has a value filter by the tags selected
  // if no tags filter by selected name
  const findblogs2 = () => {
    console.log("Karen-dataloaded=",dataloaded,rowsall)
    if (dataloaded && rowsall.length>0) {
      let rowstemp = [];
      console.log("rowsall=", rowsall);
      //console.log("seltags=", seltags);
      if (searchtext.length>0) {
        setRows(rows.filter((rowf) => (rowf.title+rowf.posttext).toLowerCase().indexOf(searchtext)>-1));
      }
      else if (seltags.length>0 && selectedname==="All Authors") {
        setRows(rowsall.filter((rowf) => rowf.tags.some(item => seltags.includes(item))));
        //setSelectedName("All Authors");
        console.log("seltags=", seltags.length)
      } else if (seltags.length>0 && selectedname!=="All Authors") {
        console.log("Karen");
        rowstemp = rowsall.filter((rowf) => rowf.tags.some(item => seltags.includes(item)));
        let selectedemail = getemail();
        setRows(rowstemp.filter((rowf) => rowf.authoremail===selectedemail));
      } else if (blogsel!="All Blogs") {
        console.log("blogsel=", blogsel);
        setRows(rowsall.filter((rowf) => rowf.blog===blogsel));
      } else {
        console.log("Karen2");
        if (selectedname==="All Authors") {
          console.log("Karen2b-rowsall=", rowsall);
          setRows(rowsall);
        } else {
          console.log("Karen3");
          console.log("selectedname=", selectedname);
          let selectedemail = getemail();
          console.log("selectedemail=", selectedemail)
          setRows(rowsall.filter((rowf) => rowf.authoremail===selectedemail));
        }
      }
      setRanFind(true);
    }
  }

  function setsessionitems(id) {
    sessionStorage.setItem('resourcetoview', id);
    sessionStorage.setItem('selectednamers', selectedname);
    sessionStorage.setItem('seltagsrs', [seltags]);
    sessionStorage.setItem('paginationtors', pagination.to);
    sessionStorage.setItem('paginationfromrs', pagination.from);
    sessionStorage.setItem('pagers', pagination.page);
    sessionStorage.setItem('pageSizers', pageSize);
    sessionStorage.setItem('sortedbyrs', sortby);
    sessionStorage.setItem('searchtext', searchtext);
    sessionStorage.setItem('returntoviewresources', "true");    
  }

  // navigate to the page that will show a particular blog post
  // add the id of the blog post to session storage so that the view blog page knows which one
  // also store the current find blog selection for later return
  function showmore(id) {
    setShowIt([...showit, { id: id }]);
    //console.log("showit=", showit);
  }

  function showless(id) {
    setShowIt(showit.filter((si) => si.id!==id));
    //console.log("showit=", showit);
  }

  function editresource(id) {
    setsessionitems(id);
    navigate('/editresource', { replace: true})
  }

  function deleteblogserved(id) {
    console.log("sortby=", sortby);
    removepost({  variables: { id } });
    //findblogs();
    setRows(rows.filter((rowf) => rowf.id!=id));
    setRanCheckSession(true);
  }

  function deleteresource(id) {
    let archive = "Y";
    editpostarchive({  variables: { id, archive } });
    setRanCheckSession(true);
  }

  const searchresources = () => {
    console.log("searchtext=", searchtext);
    setRunSearchText(true);
  }

  // this runs on a return to the getblogs page after viewing a single blog
  // use the session values to restore the most recent search
  // set ranchecksession value to true to trigger a rerun of findblogs later
  const checksession = () => {
    if (sessionStorage.getItem("returntoviewresources")==='true') {
      let sname = sessionStorage.getItem("selectednamers");
      let stags = sessionStorage.getItem("seltagsrs");
      let stext = sessionStorage.getItem("searchtext");
      setSortBy(sessionStorage.getItem("sortedbyrs"));
      if (stags && stags.length>0) {
        // set new values for tags in the dropbox; this will not change the seltags values
        setTagsToSet(stags.split(','));
        // set values for seltags
        setSelTags(stags.split(','));
      }

      if (sname && sname!=="All Authors") {
        setSelectedName(sname);
      }

      if (stext && stext.length>0) {
        console.log("stext=", stext);
        setSearchText(stext);
        setRunSearchText(true);
      }

      pagination.to = parseInt(sessionStorage.getItem("paginationtors"));
      pagination.from = parseInt(sessionStorage.getItem("paginationfromrs"));
      pagination.page = parseInt(sessionStorage.getItem("pagers"))
      setPageSize(parseInt(sessionStorage.getItem("pageSizers")));
      sessionStorage.removeItem("selectednamers");
      sessionStorage.removeItem("seltagsrs");
      sessionStorage.removeItem("returntoviewresources");
      sessionStorage.removeItem("paginationtors");
      sessionStorage.removeItem("paginationfromrs");
      sessionStorage.removeItem("pagers");
      sessionStorage.removeItem("pageSizers");
      sessionStorage.removeItem("sortedbyrs");
      sessionStorage.removeItem("searchtext");
      setRanCheckSession(true);
      //console.log("pagination=", pagination);
    }
  }

  // do initial setup of rows
  // also get author names and emails
  // this is triggered whenever number of rows (numrows) changes or rows changes
  // but only set rowsall before rows have been filtered, when there are the original number of rows
  // and only update author names and emails once
  const initializerows = () => {
    //if (rows) console.log("rows", rows, " rows.length=", rows.length, " numrows=", numrows);
    if (dataloaded && !raninit) {
      //setRowsAll(rows);
      setRanInit(true);
      console.log("numrows=", numrows);
    }
    if (dataloaded && rows.length>0 && authoremails.length===0) {
      console.log("authors");
      setAuthorEmails(sortArray(uv(rows.map((row) => row.authoremail),[])));
      setAuthorNames(sortArray(uv(rows.map((row) => row.author),["All Authors"])));
    }    
  }

  const getpagelabel = () => {
    if (dataloaded) {
      let displayfrom = pagination.from+1;
      let displayto = pagination.to;
      if (displayto > rows.length) displayto = rows.length;
      //console.log("Blogs " + displayfrom + " to " + displayto +  " out of " + rows.length);
      setPaginationLabel("Resource " + displayfrom + " to " + displayto +  " out of " + rows.length);
    }    
  }

  const setpagechange = (page, ps) => {
    const from = (page - 1) * ps;
    const to = (page - 1) * ps + ps;

    setPagination({...pagination, page: page, from: from, to: to })    
    console.log("pagination");
  }

  const handlePageChange = (e, page) => {
    setpagechange(page, pageSize);
  }

  function viewblog(id) {
    setsessionitems(id);
    //navigate('/viewpost', { replace: true})
    navigate('/viewpostdirect/' + id + '/resource', { replace: true})
  }

  /******************************** triggers ***************************/
  useEffect(() => {
    if (user.length==0) {
      //navigate("/", { replace: true})
    }
  }, []);  

  useEffect(() => {
    if (data) {
      //setRows(data.getpostscats);
      setRows(sortArray([...data.getpostscats], { by: ['createdAt'], order: 'desc'}))
      //setRowsAll(data.getpostscats);
      setRowsAll(sortArray([...data.getpostscats], { by: ['createdAt'], order: 'desc'}))
      setDataLoaded(true);
      console.log("setrows=", rows);
   }
  }, [data]);

  useEffect(() => {
    if (dataloaded) {
      setRows(sortArray([...rows], { by: ['createdAt'], order: 'desc'}))
      setNumRows(rows.length);
      console.log("dataloaded-setrows=", rows)
    }
  }, [dataloaded]);

  useEffect(() => {
    initializerows();
    getpagelabel();
    console.log("rows=", rows, "ranfind=", ranfind);
  }, [rows,numrows]);

  useEffect(() => {
    findblogs();
  }, [seltags]);

  useEffect(() => {
    findblogs();
  }, [selectedname]);

  useEffect(() => {
    console.log("blogsel", blogsel);
    findblogs();
  }, [blogsel]);

  useEffect(() => {
    findblogs();
    setRunSearchText(false);
  }, [runsearchtext]);

  // this will run after the initialization of rows
  useEffect(() => {
    if (rowsall && rowsall.length>0) {
      //getpagelabel();
      checksession();
    }
  }, [rowsall]);

  useEffect(() => {
    if (ranchecksession) {
      findblogs();
    } else {
      setRanCheckSession(false);
    }
  }, [ranchecksession]);

  useEffect(() => {
    //console.log("pagination=", pagination)
    getpagelabel();
  },[pagination.from, pagination.to, pageSize]);

  useEffect(() => {
    if (!dataloaded) return;
    console.log("sortby=", sortby)
    if (sortby==='createdAt') {
     setRows(sortArray([...rows], { by: ['createdAt'], order: 'desc'}))
     setRowsAll(sortArray([...rowsall], { by: ['createdAt'], order: 'desc'}))
    } else {
     setRows(sortArray([...rows], { by: ['position'], order: 'asc'}))
     setRowsAll(sortArray([...rowsall], { by: ['position'], order: 'asc'}))
    }
  }, [sortby]);

  useEffect(() => {
    /*if (blognamesq.data) {
      let blognamespre = blognamesq.data.getblogs;
      //console.log(blognamesq.data);
      //console.log("Karen--blognamesq.data");
      setBlognames(sortArray(blognamespre.map((blognamespre) => blognamespre.blogtitle)));
   }*/
  }, [blognamesq.data]);

  useEffect(() => {
    console.log("showit=", showit);
  }, [showit]);


  useEffect(() => {
    console.log("blognames=", blognames);
    if (blognames.length>0) {
      setShowblognames(true);
    } 
  }, [blognames]);

  if (loading) {
    return <p>loading...</p>;
  }

  if (error) {
    //console.log(error)
    return <p>Ruh roh! {error.message}</p>;
  }

  /**************************************** helper functions ********************************/

  // show only the first 350 characters of a blog post
  const getWordStr = (mytext, chars) => {
    let newvalue = mytext;
    if (newvalue.length>=chars) {
      newvalue = newvalue.toString().substring(0,chars) + ".....";
    }
    return newvalue;
  }

  const uv = (oldarray, startvalue) => {
    const uniqueValues = startvalue;
    oldarray.map((item) => {
      if (uniqueValues.indexOf(item) === -1) {
          uniqueValues.push(item)
      }
    });
    return uniqueValues;
  }

  const handleChangeLink = (e, value) => {
    setGoToLink(value);
    navigate(value, { replace: true})
  }

  const handleNameSelect = (e, value) => {
    setSelectedName(e.target.value);
    //setTagsToSet([]);
  }

  const handleBlogSelect = (e, value) => {
    setBlogsel(e.target.value);
    //setTagsToSet([]);
  }

  const gettags = (data) => {
    setTagStatus("tagsdeselected");
    setSelTags(data);
  }

  const handleFindClick = () => {
    findblogs();
    pagination.page = 1;
  }

  // get the e-mail address associated with the selected name
  const getemail = () => {
    let email = "";
    let sr = rowsall.filter((row) => row.author===selectedname);
    console.log("sr=", sr);
    email = sr[0].authoremail;
    return email;
  }

  const handlePageSize = (e, value) => {
    console.log("e.target.value=", e.target.value);
    setPageSize(e.target.value);
    setpagechange(pagination.page, e.target.value);
  }

  const getlink = (id) => {
    return 'https://community.collegeunbound.edu/viewpostdirect/' + id + '/resource'
  }

  const foundid = (id) => {
    if (showit.length===0) return false;
    let found = false;
    found = showit.find(o => o.id === id);
    return found;
  }

  const handleSearchChange = (e, value) => {
    let currenttext = e.target.value;
    setSearchText(currenttext);
    if (currenttext.length===0) setRunSearchText(true);
;
  }


  return (
    <div align="left">

    <Stack direction="row" alignItems="center" sx={{ justifyContent: 'center', width: '100%', backgroundColor: '#47494d', color: 'white' }}>
      <Typography variant="h5">Resources</Typography>
    </Stack>

      <Stack direction="row" alignItems="center" sx={{ justifyContent: 'space-between', width: '600px', ml: 2, mt: 2, pb: 2 }}>
        <ToggleButtonGroup value={gotolink} color="primary" exclusive onChange={handleChangeLink}>
          <ToggleButton value="/getresources">View Resources</ToggleButton>
          <ToggleButton value="/addresource">Add Resource</ToggleButton>
        </ToggleButtonGroup>
      </Stack>

      { dataloaded && (

      <Stack direction='column'>
      <Stack direction='row'>
        <Stack display="flex" alignItems="Left" direction='column' sx={{ bgcolor: '#EAFAF1', color: "white", justifyContent: "space-evenly", height: 520, width: 350 }}>

          <Stack direction='row'>
            <TextField id="search" onChange={handleSearchChange} value={searchtext} label={<Typography sx={{fontWeight: 500, fontSize: 16}}>Search title and description</Typography>} type="search" variant="standard" sx={{ ml: 3, mt: 3, mb: 3, textAlign:"left", width:300, fontSize: "10px"}}></TextField>
            <IconButton sx={{ color: green[500], width: 20, height: 20, mt: 5 }} onClick={searchresources}><FindInPageIcon /></IconButton>
          </Stack>

          <FormHelperText sx={{ fontSize: 16, fontWeight: 500, ml: 3, mr: 2, mt: 2 }}>Tags</FormHelperText>

          <Box sx={{ ml: 3, mb: 2, fontSize: 12 }}>
            <Taglistabb functags={gettags} cleartags={clearthetags} setthetags={tagstoset} width={"310px"} />
          </Box>

          {/*<Box sx={{ fontSize: 16, fontWeight: 'Bold', ml: 3 }}>Find Blogs by Author</Box>*/}

          { authornames.length>0 && (

          <>
          <TextField type={'text'} value={selectedname} onChange={handleNameSelect} sx={{ ml: 3, mt: 3, mb: 1, textAlign:"left", width:310, fontSize: 16, fontWeight: 500}} defaultValue="All Authors" select multiple variant="standard">
            {authornames.map((option, index) => (
              <MenuItem key={index} value={option}>{option}</MenuItem>
            ))}
          </TextField>
          </>

          )}

          <Stack direction='row'>
            <Select value={sortby} onChange={(e) => setSortBy(e.target.value)} variant="standard" sx={{ ml: 3, mt: 4, width: 310, fontSize: 16, fontWeight: 400 }} >
              <MenuItem value="createdAt" >Sort by Posted Date</MenuItem>
              <MenuItem value="position" >Sort by Position</MenuItem>
            </Select>
          </Stack>


        </Stack>

        <Grid container direction='row' sx={{ml: 7, width: 650}}>


        {rows.slice(pagination.from,pagination.to).map((post, index) => (
          <Grid item key={post.id} align="left">

            <Card key={"card" + post.id} sx={{ width: 200, minHeight: 280 }}>
              <CardContent>
                <Box sx={{ fontSize: 12, fontWeight: 600, display: 'flex', justifyContent: 'flex-start', minHeight: 40}}>
                  <Typography sx={{ fontSize: 14, fontWeight: 'Bold'}} >{post.title}</Typography>
                </Box>

                {foundid(post.id) ? (
                  <>
                    <Typography sx={{ fontSize: 12}}>{parser(getWordStr(post.posttext, 500))}</Typography>
                    { (post.authoremail===user.email || user.email==='michael.walker@collegeunbound.edu') ? ( 
                      <>
                        <Box sx={{display: 'flex', justifyContent: 'center', alignSelf: 'flex-end'}}>
                          <Tooltip title="Edit" placement="top"><IconButton name="editresource" sx={{ color: yellow[700], width: 20, height: 20 }} onClick={() => editresource(post.id) }><EditIcon /></IconButton></Tooltip>
                          <Tooltip title="Delete" placement="top"><IconButton name="deleteresource" sx={{ color: red[500], width: 20, height: 20, ml: 2 }} onClick={() => deleteresource(post.id) }><DeleteIcon /></IconButton></Tooltip>
                          <Tooltip title="View Details" placement="top"><IconButton sx={{ color: green[500], width: 20, height: 20, ml: 2 }} onClick={() => viewblog(post.id) }><QuickreplyIcon /></IconButton></Tooltip>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Box sx={{display: 'flex', justifyContent: 'center', alignSelf: 'flex-end'}}>
                          <Tooltip title="View Details" placement="top"><IconButton sx={{ color: green[500], width: 20, height: 20 }} onClick={() => viewblog(post.id) }><QuickreplyIcon /></IconButton></Tooltip>
                        </Box>
                      </>
                    )}
                    <Grid container direction="column" align='left' sx={{ mt: 1, mb: 2, fontSize: 12}}>
                    {post.file.map((f, index) => (
                    <Grid item>
                      <GetSignedFileUrl filelink={f.filelink} filename={getWordStr(f.filename,25)}/>
                    </Grid>
                    ))}
                    {post.resourcelink.map((f, index) => (
                    <Grid item sx={{display: 'flex', justifyContent: 'center', alignSelf: 'flex-end'}}>
                      <Link href={f.resourcelinkurl} target="_blank" rel="noopener">{getWordStr(f.resourcelinkname, 25) }</Link>
                    </Grid>
                    ))}
                    </Grid>
                    <Typography sx={{ fontSize: 12}}>{"Tags: " + post.tags.join(" / ")}</Typography>
                    <Typography sx={{ fontSize: 12}}>{ "Position: " + post.position }</Typography>
                    <Typography sx={{ fontSize: 12}}>{ "Posted: " + moment(parseFloat(post.createdAt)).format('MM/DD/YY') }</Typography>
                    <Tooltip title="Copy Link" placement="top">
                      <Box sx={{display: 'flex', justifyContent: 'left', alignSelf: 'flex-end'}}>
                        <CopyToClipboard text={getlink(post.id)}>
                          <IconButton sx={{ color: blue[500], width: 20, height: 30, m: 2 }} ><ShareIcon /></IconButton>
                        </CopyToClipboard>
                      </Box>
                    </Tooltip>
                    <Getuserinfo email={post.authoremail} first="avatar" />
                    <Box sx={{display: 'flex', justifyContent: 'center', alignSelf: 'flex-end'}}>
                      <IconButton sx={{ color: green[500], width: 20, height: 20, ml: 2, display: 'flex', alignItems: 'center' }} onClick={() => showless(post.id) }><ExpandLessIcon /></IconButton>
                    </Box>
                  </>
                ) : (
                  <>
                    <Box sx={{ minHeight: 125 }}>
                      <Typography sx={{ fontSize: 12 }}>{parser(getWordStr(post.posttext, 150))}</Typography>
                    </Box>
                    { (post.authoremail===user.email || user.email==='michael.walker@collegeunbound.edu') ? ( 
                      <>
                        <Box sx={{display: 'flex', justifyContent: 'center', alignSelf: 'flex-end'}}>
                          <Tooltip title="Edit" placement="top"><IconButton name="editresource" sx={{ color: yellow[700], width: 20, height: 20 }} onClick={() => editresource(post.id) }><EditIcon /></IconButton></Tooltip>
                          <Tooltip title="Delete" placement="top"><IconButton name="deleteresource" sx={{ color: red[500], width: 20, height: 20, ml: 2 }} onClick={() => deleteresource(post.id) }><DeleteIcon /></IconButton></Tooltip>
                          <Tooltip title="View Details" placement="top"><IconButton sx={{ color: green[500], width: 20, height: 20, ml: 2 }} onClick={() => viewblog(post.id) }><QuickreplyIcon /></IconButton></Tooltip>
                        </Box>
                      </>
                    ) : (
                      <>
                        <Box sx={{display: 'flex', justifyContent: 'center', alignSelf: 'flex-end'}}>
                          <Tooltip title="View Details" placement="top"><IconButton sx={{ color: green[500], width: 20, height: 20 }} onClick={() => viewblog(post.id) }><QuickreplyIcon /></IconButton></Tooltip>
                        </Box>
                      </>

                    )}
                    <Grid container direction="column" align='left' sx={{ mt: 1, mb: 2, fontSize: 12}}>
                    {post.file.map((f, index) => (
                    <Grid item>
                      <GetSignedFileUrl key={"sfile" + post.id} filelink={f.filelink} filename={getWordStr(f.filename,25)}/>
                    </Grid>
                    ))}
                    {post.resourcelink.map((f, index) => (
                    <Grid item>
                      <Link key={"rlink" + post.id} href={f.resourcelinkurl} target="_blank" rel="noopener">{getWordStr(f.resourcelinkname,25)}</Link>
                    </Grid>
                    ))}
                    </Grid>
                    <Box sx={{display: 'flex', justifyContent: 'center', alignSelf: 'flex-end'}}><IconButton sx={{ color: green[500], width: 20, height: 20, ml: 2, display: 'flex', justifyContent: 'center', alignSelf: 'flex-end' }} onClick={() => showmore(post.id) }><ExpandMoreIcon /></IconButton></Box>
                  </>
                )}
                {/*<Typography sx={{ fontSize: 10 }} color="text.secondary">{ row.Role!==undefined && row.Role.join(" / ") }</Typography>*/}

              </CardContent>
            </Card>

          </Grid>
        ))}

        </Grid>
     
      </Stack>

      <Stack direction='row' sx={{mt: 5}}>

        <Box sx={{ fontSize: 14, width: 425, ml: 3, mb: 2 }}></Box>

        <Stack direction='column'>


            <Box sx={{ fontSize: 14, ml: 3, mb: 2 }}>{paginationlabel}</Box>


            <Stack direction="row">
              <Pagination count={Math.ceil(rows.length/pageSize)} page={pagination.page} onChange={handlePageChange} color="primary" />
              <FormHelperText sx={{ fontSize: 11, ml: 3, mr: 2 }}>Page Size</FormHelperText>
              <Select value={pageSize} onChange={handlePageSize} label="Page Size" sx={{height: 24}} >
                <MenuItem value={6}>6</MenuItem>
                <MenuItem value={9}>9</MenuItem>
                <MenuItem value={12}>12</MenuItem>
                <MenuItem value={15}>15</MenuItem>
                <MenuItem value={18}>18</MenuItem>
              </Select>
            </Stack>


          </Stack>

        </Stack>


      </Stack>

      )}
    
    </div>
  );


}

export default Getresources;